
export default {
  mounted() {
    this.$nextTick(() => {
      this.$gsap.set(this.$refs.rings, {
        transformOrigin: 'center',
      })
      this.$gsap.fromTo(
        this.$refs.rings,
        {
          rotate: 0,
        },
        {
          rotation: 360,
          duration: 60,
          repeat: -1,
          ease: 'linear',
        }
      )
    })
  },
}
